/** 首页大标题内容，存于 pages 表（slug = home-hero，JSON 格式） */
export interface HeroContent {
  title_pre: string;
  title_highlight: string;
  title_post: string;
  subtitle: string;
}

export const defaultHero: HeroContent = {
  title_pre: '写作，是为了',
  title_highlight: '更好地',
  title_post: '思考。',
  subtitle: '记录代码、架构与生活中的灵感片段。每一篇文章都是一颗漂浮在数字星空中的星星。',
};

/** 解析 DB 里的 JSON，缺字段或解析失败时回落到默认值 */
export function parseHero(contentMd?: string): HeroContent {
  if (!contentMd) return defaultHero;
  try {
    return { ...defaultHero, ...JSON.parse(contentMd) };
  } catch {
    return defaultHero;
  }
}
